module.exports = __webpack_public_path__ + "tabs_list.42b60cfe2086bf3f3c44.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tabs_list.svg
// module id = ./src/assets/img/tabs_list.svg
// module chunks = main